import apiCrud from '../../abstract/api-crud';
import apiPaths from '../../../../api-v2/api-paths';

const baseUri = `${ apiPaths.CRM }/mail-groups`;
export const modelName = 'mail-groups';

export default {
  ...apiCrud({ baseUri, modelName }),
};